import { Form } from "components/Forms";
import { buildWidgetInstanceId } from "features/widgets";
import { WIDGETS_REGISTRY } from "features/widgets/widgets.config";
import { useRouter } from "next/router";
import {
  Action,
  Heading4,
  Icon,
  ModalWrapper,
  PageLink,
  Paragraph,
} from "shared/components";
import { useToggle } from "shared/hooks";

import styles from "./RightBlock.module.scss";

export const RightBlock = ({ ...payload }) => {
  const title = payload?.rightTitle ?? "";
  const description = payload?.rightDescription ?? "";
  const buttonText = payload?.rightButton?.buttonText ?? "";
  const link = payload?.rightButton?.link ?? "";
  const type = payload?.rightButton?.type ?? "form";
  const form = payload?.rightButton?.form ?? {};

  const instanceId = buildWidgetInstanceId(
    "085rightBlock",
    payload.id,
    WIDGETS_REGISTRY.CONTENT
  );

  const { query } = useRouter();

  const { opened, onOpen, onClose } = useToggle();

  return (
    <div className={styles.wrapper}>
      <Heading4 color="light" className={styles.title}>
        {title}
      </Heading4>
      <Paragraph color="light" className={styles.description}>
        {description}
      </Paragraph>
      {type === "form" ? (
        <Action onClick={onOpen} className={styles.button}>
          <Paragraph color="light" appearance="bigger">
            {buttonText}
          </Paragraph>
          <Icon className={styles.icon} name="arrow_right" />
        </Action>
      ) : (
        <PageLink className={styles.button} link={link}>
          <Paragraph color="light" appearance="bigger">
            {buttonText}
          </Paragraph>
          <Icon className={styles.icon} name="arrow_right" />
        </PageLink>
      )}
      {opened && (
        <ModalWrapper onCloseModal={onClose}>
          <Form
            item={form}
            metaData={{ page: query.slug }}
            instanceId={instanceId}
            onReset={onClose}
          />
        </ModalWrapper>
      )}
    </div>
  );
};

export default RightBlock;
